<template>
  <div>
    <AlertDismiss ref="alertDismiss" />
    <button
      class="btn btn-outline-success btn-sm w-100"
      @click="onclick"
      :disabled="!enableButton"
    >
      <b-spinner v-if="isDownloading" small class="me-2"></b-spinner>
      Descargar
      <b-icon icon="file-earmark-excel" class="me-2"></b-icon>
    </button>
  </div>
</template>

<script>
import AlertDismiss from '@/components/shared/Alert-dismiss.vue';
import { generateExcel } from '@/plugins/exceljs';

export default {
  name: 'ExcelExport',

  components: {
    AlertDismiss
  },

  props: {
    data: Array,
    fields: {
      type: Object,
      required: true
    },
    worksheet: {
      type: String,
      default: 'Sheet1'
    },
    name: {
      type: String,
      default: 'excel.xlsx'
    }
  },

  data() {
    return {
      isDownloading: false
    };
  },

  computed: {
    enableButton() {
      return this.data && !this.isDownloading
    }
  },

  methods: {
    async onclick() {
      this.isDownloading = true;
      setTimeout(async () => { // otherwise vue runtime gets lock and does update is downloading
        try {
          await generateExcel(this.data, this.fields, this.worksheet, this.name);
        } catch (error) {
          this.$refs.alertDismiss.showAlert(`Error al exportar a Excel: ${error.message}`, 'danger');
        } finally {
          this.isDownloading = false;
        }
      }, 200);
    }
  },
};
</script>
